import React from 'react';
import { Card } from '@mui/material';
import { AccelCap, AccelCapStyles } from 'components/views/molecules/DrivingSettings/AccelCap';

export type DrivingSettingPanelProps = {
    accelCap: number;
    onAccelCap: (accelCap: number) => void;
    accelScale: number;
    onAccelScale: (accelScale: number) => void;
    useStyles?: () => AccelCapStyles;
}

export function DrivingSettingsPanel(props: DrivingSettingPanelProps) {
    const { accelCap, onAccelCap } = props;
    const { accelScale, onAccelScale } = props;

    return (
        <Card>
            <AccelCap accelCap={accelCap} onAccelCap={onAccelCap} />
            <AccelCap caption={'Acceleration Scale'} accelCap={accelScale} onAccelCap={onAccelScale} />
        </Card>
    );
}
